function parseDate(date) {
  try {
    return date.split('T')[0].split('-').reverse().join('-');
  } catch {
    return '';
  }
}

function formatDateToLocalString(dateString, nexus) {
  const userDate = new Date(dateString);
  const hours = String(userDate.getHours()).padStart(2, '0');
  const minutes = String(userDate.getMinutes()).padStart(2, '0');
  const date = String(userDate.getDate()).padStart(2, '0');
  const month = String(userDate.getMonth() + 1).padStart(2, '0');
  const year = String(userDate.getFullYear());

  return `${hours}:${minutes} ${nexus} ${date}-${month}-${year}`;
}

function formatDateAndTime(dateString) {
  const userDate = new Date(dateString);
  const hours = String(userDate.getHours()).padStart(2, '0');
  const minutes = String(userDate.getMinutes()).padStart(2, '0');
  const date = String(userDate.getDate()).padStart(2, '0');
  const month = String(userDate.getMonth() + 1).padStart(2, '0');
  const year = String(userDate.getFullYear());

  return `${date}-${month}-${year} ${hours}:${minutes}`;
}

/**
 * Parsea la fecha a formato local (fecha completa)
 * @param {*} dateStr Fecha a parsear
 * @returns Fecha parseada
 */
const parseLocalDate = (dateStr) => new Date(dateStr)
  .toLocaleString('es-CL', {
    timeZone: 'America/Santiago',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  })
  .replace(/\//g, '-')
  .replace(', ', ' ');

/**
 * Parsea la fecha a fecha completa
 * @param {*} dateStr Fecha a parsear
 * @returns Fecha parseada
 */
const parseCompleteDate = (dateStr) => {
  if (!dateStr) return '-';
  return new Date(dateStr)
    .toLocaleString('es-CL', {
      timeZone: 'UTC',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    })
    .replace(/\//g, '-')
    .replace(', ', ' ');
};

const getDuration = (startedAt, finishedAt) => {
  if (!startedAt || !finishedAt) return '';

  const start = new Date(startedAt);
  const end = new Date(finishedAt);

  if (start > end) return 'Error';

  const diffMs = end - start;

  if (diffMs >= 24 * 60 * 60 * 1000) {
    return '+24:00:00';
  }

  const totalSeconds = Math.floor(diffMs / 1000);

  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return [
    String(hours).padStart(2, '0'),
    String(minutes).padStart(2, '0'),
    String(seconds).padStart(2, '0'),
  ].join(':');
};

const shouldHighlightDuration = (startedAt, finishedAt, label) => {
  if (!startedAt || !finishedAt) return false;

  const diffMs = new Date(finishedAt) - new Date(startedAt);

  if (diffMs < 0) return false;

  const mysteryShopperLimit = 10 * 60 * 1000; // 10 min
  const audLimit = 30 * 60 * 1000; // 30 min

  switch (label) {
    case 'mystery_shopper':
      return diffMs < mysteryShopperLimit;

    case 'audit':
      return diffMs < audLimit;

    default:
      return false;
  }
};

const getLabelOptions = (t) => [
  {
    name: t('task.taskForm.withoutLabel'),
    value: '',
  },
  {
    name: t('task.taskForm.audit'),
    value: 'audit',
  },
  {
    name: t('task.taskForm.mysteryShopper'),
    value: 'mystery_shopper',
  },
];

export {
  parseDate,
  formatDateToLocalString,
  formatDateAndTime,
  parseLocalDate,
  parseCompleteDate,
  getDuration,
  shouldHighlightDuration,
  getLabelOptions,
};
